// API Configuration
export const BACKEND_URL = (typeof window !== "undefined" && window.location && window.location.origin ? window.location.origin : process.env.REACT_APP_BACKEND_URL);
export const API = `${BACKEND_URL}/api`;

// Dynamische Jahre berechnen (ab 2016 bis aktuelles Jahr)
const currentYear = new Date().getFullYear();
const START_YEAR = 2016;
const years = [];
for (let y = currentYear; y >= START_YEAR; y--) {
  years.push(y);
}
export const AVAILABLE_YEARS = years;

// German month names
export const MONTH_NAMES = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

// Weekday order
export const WEEKDAY_ORDER = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];

// Comment reasons for customer form
export const COMMENT_REASONS = [
  "Überlegt noch", "Zu teuer / Budget", "Wohnt zu weit weg", "Kommt nicht oft genug",
  "Kein Interesse", "Möchte erst testen", "Hat woanders Abo", "Mit Partner abklären",
  "Nur Gutschein nutzen", "Zu wenig Zeit", "Nur zu Besuch",
  "Kunde kommt nur zum Vorbräunen vor dem Urlaub", "Sonstiges"
];

// Additional options for contracts
export const ADDITIONAL_OPTIONS = ["EMP Chair", "Bodystyler", "BSL Beauty Light", "Bodystyler + BSL Beauty Light"];

// Additional option prices
export const ADDITIONAL_OPTION_PRICES = {
  "EMP Chair": 10,
  "Bodystyler": 10,
  "BSL Beauty Light": 5,
  "Bodystyler + BSL Beauty Light": 13
};
